import { Route } from 'react-router-dom';
import FAQPage from './pages/FAQPage';

export const FAQRoutes = [
  <Route key="faq" path="/dashboard/faq" element={<FAQPage />} />
];